(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-page-title"] && !Shopify.designMode) return;
  try {
    
    // Code JavaScript pour obtenir et afficher la date actuelle
    const options = { day: 'numeric', month: 'short' };
    const currentDate = new Date().toLocaleDateString('fr-FR', options);

    // Remplace le nom anglais des mois par les abréviations françaises correspondantes
    const frenchDate = currentDate.replace('janv.', 'Jan').replace('févr.', 'Fév').replace('mars', 'Mar')
                                  .replace('avr.', 'Avr').replace('mai', 'Mai').replace('juin', 'Jun')
                                  .replace('juil.', 'Jul').replace('août', 'Août').replace('sept.', 'Sep')
                                  .replace('oct.', 'Oct').replace('nov.', 'Nov').replace('déc.', 'Déc');

    // Afficher la date formatée dans l'élément HTML avec l'ID "currentDate"
    // document.getElementById('currentDate').textContent = `Commandez avant le ${frenchDate} pour des réductions garanties & des cadeaux GRATUITS`;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-promotion-bottom"] && !Shopify.designMode) return;
  try {
    
  function startCountdown(duration) {
      let timer = duration * 60 * 60; // Convert hours to seconds
      const countdownElement = document.getElementById('countdown2');

      function updateCountdown() {
        const hours = Math.floor(timer / 3600);
        const minutes = Math.floor((timer % 3600) / 60);
        const seconds = timer % 60;

        countdownElement.innerHTML = `${formatTime(hours)}:${formatTime(minutes)}:${formatTime(seconds)}`;

        if (timer <= 0) {
          clearInterval(countdownInterval);
          countdownElement.innerHTML = 'Countdown Completed!';
        } else {
          timer--;
        }
      }

      function formatTime(time) {
        return time < 10 ? `0${time}` : time;
      }

      updateCountdown(); // Initial call to display the initial value

      const countdownInterval = setInterval(updateCountdown, 1000); // Update every second
    }

    // Start the countdown with 8 hours
    startCountdown(8);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-promotion"] && !Shopify.designMode) return;
  try {
    
  function startCountdowns(duration) {
      let timer = duration * 60 * 60; // Convert hours to seconds
      const countdownElement = document.getElementById('countdown');

      function updateCountdowns() {
        const hours = Math.floor(timer / 3600);
        const minutes = Math.floor((timer % 3600) / 60);
        const seconds = timer % 60;

        countdownElement.innerHTML = `${formatTime(hours)}:${formatTime(minutes)}:${formatTime(seconds)}`;

        if (timer <= 0) {
          clearInterval(countdownsInterval);
          countdownElement.innerHTML = 'Compte à Rebours Terminé!';
        } else {
          timer--;
        }
      }

      function formatTime(time) {
        return time < 10 ? `0${time}` : time;
      }

      updateCountdowns(); // Initial call to display the initial value

      const countdownsInterval = setInterval(updateCountdowns, 1000); // Update every second
    }

    // Start the countdowns with 8 hours
    startCountdowns(0.08);

  } catch(e) { console.error(e); }
})();
})();
